import { useContainerRelativePosition } from '../hooks/useContainerRelativePosition'
import {
  PopoverElementKind,
  useHoverCardPosition,
} from '../hooks/useHoverCardPosition'

import { Box, Popover, PopoverArrow, PopoverContent } from '@chakra-ui/react'

import { PopoverTrigger } from '@/components/ui'

export interface IProps {
  children: React.ReactNode
  elementId: string
  kind?: PopoverElementKind
  isHovering: boolean
  forceCloseSignal?: number
  forceOpenSignal?: number
}

export const FloorPlanPopover = ({
  isHovering = false,
  elementId,
  children,
  kind,
  forceCloseSignal,
  forceOpenSignal,
}: IProps) => {
  const {
    triggerPosition,
    isOpen,
    onContentMouseEnter,
    onContentMouseLeave,
    onPopoverClose,
  } = useHoverCardPosition({
    elementId,
    isHovering,
    kind,
    forceCloseSignal,
    forceOpenSignal,
  })

  const { width, height } = triggerPosition
  const { anchorRef, left, top } = useContainerRelativePosition(triggerPosition)
  return (
    <Popover
      autoFocus={false}
      closeOnBlur={true}
      isLazy
      isOpen={isOpen}
      offset={[8, 8]}
      onClose={onPopoverClose}
      returnFocusOnClose={false}
      // Not 'hover': Chakra's own hover trigger schedules an unconditional
      // close on mouseleave that can't be cancelled, which used to kill a
      // card re-opened right after. Open/close is fully driven by the hook.
      // autoFocus/returnFocusOnClose default true under Chakra's default
      // 'click' trigger, which would steal focus from e.g. a search input
      // whenever the pointer happens to rest on a marker long enough to
      // open the card.
    >
      <PopoverTrigger>
        {/* Anchor only, for Popper to position against — pointerEvents='none'
            so a stale rect can never intercept a click on the canvas. left/top
            are the marker rect mapped into the anchor's positioned ancestor by
            useContainerRelativePosition, so the card tracks its marker at any
            side-nav width. */}
        <Box
          height={height}
          left={left}
          pointerEvents='none'
          pos='absolute'
          ref={anchorRef}
          top={top}
          width={width}
        />
      </PopoverTrigger>
      <PopoverContent
        border='none'
        onMouseEnter={onContentMouseEnter}
        onMouseLeave={onContentMouseLeave}
        shadow='xl'
        width={kind === 'tailgate' ? '320px' : '400px'}
      >
        <PopoverArrow border='none' />
        {children}
      </PopoverContent>
    </Popover>
  )
}
